import { FC, useState } from 'react';

import PassworkValidatingStatus from 'components/form/PassworkValidatingStatus';
import AuthWrapper from 'components/modules/AuthWrapper';
import Button from 'components/primitives/Button';
import PasswordInput from 'components/primitives/PasswordInput';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { ResetPasswordProps } from './ResetPassword.props';

const validationSchema = Yup.object().shape({
  password: Yup.string()
    .min(8, 'Password must be at least 8 characters')
    .required('Password is required'),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('password')], 'Passwords must match')
    .required('Confirm password is required'),
});

const initialValues = {
  password: '',
  confirmPassword: '',
};

const ResetPasswordView: FC<ResetPasswordProps> = ({
  onSubmit,
  isLoading,
  goToLogin,
  code,
}) => {
  const [showPasswordStatus, setShowPasswordStatus] = useState<boolean>(false);

  return (
    <AuthWrapper>
      <h2 className="text-center">Reset Password</h2>
      <p className="font-secondary text-center mt-1">
        Enter your email and create a new password
      </p>
      <div className="justify-center items-center place-items-center m-4">
        <Formik
          initialValues={initialValues}
          onSubmit={onSubmit}
          validationSchema={validationSchema}>
          {({ values, setFieldValue }) => {
            return (
              <Form>
                <div className="flex flex-col justify-center">
                  <PasswordInput
                    name="password"
                    placeholder="New password"
                    hideErrorComponent={true}
                    onKeyUp={() => setShowPasswordStatus(true)}
                  />

                  <PassworkValidatingStatus hide={!showPasswordStatus} />

                  <PasswordInput
                    name="confirmPassword"
                    placeholder="Confirm new password"
                  />

                  <Button
                    id="open-btn"
                    type="submit"
                    variant="solid"
                    isLoading={isLoading}
                    colorScheme="primary"
                    className="btn-var-solid w-full h-auto btn-var-solid mt-5">
                    Reset Password
                  </Button>
                </div>
              </Form>
            );
          }}
        </Formik>
      </div>

      <div className="flex flex-row justify-center mt-5 text-gray-600">
        <p className="text-sm">Remember your password?&nbsp;</p>
        <p
          onClick={goToLogin}
          className="text-sm text-primary-500 cursor-pointer">
          Log in
        </p>
      </div>
    </AuthWrapper>
  );
};

export default ResetPasswordView;
